import React, { useState } from "react";
import { useMount } from "react-use";
import { css } from "@emotion/core";
import { Desktop, Tablet } from "../../constants/responsive";
import { FormattedHTMLMessage, Link, useIntl } from "gatsby-plugin-intl";
import Container from "../../components/Container";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../../components/Layout";
import SEO from "../../components/SEO";
import BannerQuote from "../../components/BannerQuote";
import Button from "../../components/Button";
import ScrollContainer from "react-indiana-drag-scroll";
import "../../styles/about/who-we-are.scss";

const StartEndPadding = ({ mobileOnly = false }) => {
  return (
    <div
      css={css`
        flex: 0 0 auto;
        display: block;
        width: 20px;
        ${Tablet} {
          ${!mobileOnly ? "width: calc(50vw - 364px);" : "display: none;"}
        }
        ${Desktop} {
          display: none;
        }
      `}
    ></div>
  );
};

const MyImg = ({ imgInfo }) => {
  return (
    <img
      className="my-img"
      src={`/about/who-we-are/${imgInfo.name}.png`}
      css={css`
        width: ${imgInfo.width[0]}px;
        ${Tablet} {
          width: ${imgInfo.width[1]}px;
        }
        ${Desktop} {
          width: ${imgInfo.width[2]}px;
        }
      `}
    />
  );
};

const WhoWeArePage = () => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      banner: file(relativePath: { eq: "who-we-are/banner.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      timelineApp: file(relativePath: { eq: "who-we-are/timeline-app.png" }) {
        childImageSharp {
          fluid(maxWidth: 150) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      kelvin: file(relativePath: { eq: "who-we-are/kelvin.png" }) {
        childImageSharp {
          fluid(maxWidth: 255) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      don: file(relativePath: { eq: "who-we-are/don.png" }) {
        childImageSharp {
          fluid(maxWidth: 255) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      kenneth: file(relativePath: { eq: "who-we-are/kenneth.png" }) {
        childImageSharp {
          fluid(maxWidth: 255) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      jacky: file(relativePath: { eq: "who-we-are/jacky.png" }) {
        childImageSharp {
          fluid(maxWidth: 255) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      edigest: file(relativePath: { eq: "who-we-are/edigest.png" }) {
        childImageSharp {
          fluid(maxWidth: 160) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      hkict: file(relativePath: { eq: "who-we-are/hkict.png" }) {
        childImageSharp {
          fluid(maxWidth: 141) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      blue: file(relativePath: { eq: "who-we-are/blue.png" }) {
        childImageSharp {
          fluid(maxWidth: 141) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      etnet: file(relativePath: { eq: "who-we-are/etnet.png" }) {
        childImageSharp {
          fluid(maxWidth: 109) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      deloitte: file(relativePath: { eq: "who-we-are/deloitte.png" }) {
        childImageSharp {
          fluid(maxWidth: 189) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      synced: file(relativePath: { eq: "who-we-are/synced.png" }) {
        childImageSharp {
          fluid(maxWidth: 181) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      kpmg: file(relativePath: { eq: "who-we-are/kpmg.png" }) {
        childImageSharp {
          fluid(maxWidth: 181) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      szfcia: file(relativePath: { eq: "who-we-are/szfcia.png" }) {
        childImageSharp {
          fluid(maxWidth: 181) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      iegc: file(relativePath: { eq: "who-we-are/iegc.png" }) {
        childImageSharp {
          fluid(maxWidth: 181) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ftsu: file(relativePath: { eq: "who-we-are/ftsu.png" }) {
        childImageSharp {
          fluid(maxWidth: 181) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      hkust: file(relativePath: { eq: "who-we-are/hkust.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      alibaba: file(relativePath: { eq: "who-we-are/alibaba.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      bohai: file(relativePath: { eq: "who-we-are/bohai.png" }) {
        childImageSharp {
          fluid(maxWidth: 213) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      lenovo: file(relativePath: { eq: "who-we-are/lenovo.png" }) {
        childImageSharp {
          fluid(maxWidth: 92) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      cyberport: file(relativePath: { eq: "who-we-are/cyberport.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      zhengHe: file(relativePath: { eq: "who-we-are/zheng-he.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 92) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      twosigma: file(relativePath: { eq: "who-we-are/twosigma.png" }) {
        childImageSharp {
          fluid(maxWidth: 150) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  // 时间线进程中年份与图片（及图片宽度）的映射
  const timeLineMap = {
    2016: {},
    2017: {
      pics: [
        { name: "alibaba", width: [79, 86, 86] },
        { name: "HKUST", width: [79, 86, 86] },
        { name: "GOBI", width: [70, 77, 77] },
      ],
    },
    2018: {
      seperatePics: [],
    },
    2019: {
      pics: [
        { name: "aia", width: [68, 76, 90] },
        { name: "CWLB", width: [85, 94, 111] },
        { name: "GRCB", width: [80, 87, 103] },
      ],
    },
    2020: {
      pics: [
        { name: "lenovo", width: [43, 43, 43] },
        { name: "cyberport", width: [100, 100, 100] },
      ],
    },
    2021: {
      pics: [
        { name: "CITIC", width: [78, 80, 100] },
        { name: "forthright", width: [81, 83, 103] },
        { name: "huatai", width: [76, 78, 111] },
      ],
    },
    2022: {},
  };

  const [isClient, setClient] = useState(false);
  useMount(() => {
    setClient(true); // 用来改变key,使得组件重新渲染
  });
  return (
    <Layout footerBlank>
      <SEO
        title={intl.formatMessage({ id: "who-we-are.title" })}
        description={intl.formatMessage({ id: "who-we-are.description" })}
        keywords={intl.formatMessage({ id: "who-we-are.keywords" })}
      />
      <div
        css={css`
          background: #f2f2f2;
          width: 100%;
          height: 400px;
          border-bottom-left-radius: 50% 6%;
          border-bottom-right-radius: 50% 6%;
          display: flex;
          justify-content: center;
          position: relative;
          overflow: hidden;
          ${Tablet} {
            height: 340px;
            border-bottom-left-radius: 50% 12%;
            border-bottom-right-radius: 50% 12%;
          }
          ${Desktop} {
            border-bottom-left-radius: 50% 13%;
            border-bottom-right-radius: 50% 13%;
            height: 550px;
          }
        `}
      >
        <div
          css={css`
            position: absolute;
            width: 100vw;
            min-width: 1200px;
            transform: translate(-15%, 0%);
            ${Tablet} {
              width: 100vw;
              min-width: 1100px;
              transform: translate(0, 0%);
            }
            ${Desktop} {
              width: 100vw;
              min-width: 1800px;
              transform: translate(0, 0%);
            }
          `}
        >
          <Img
            fluid={data.banner.childImageSharp.fluid}
            imgStyle={{ objectFit: "fill" }}
            loading="eager"
          />
        </div>
        <div
          css={css`
            position: absolute;
            width: 100vw;
            height: 100%;
            min-width: 320px;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.9) 0%,
              rgba(0, 0, 0, 0.5) 30%,
              rgba(0, 0, 0, 0) 100%
            );
            ${Tablet} {
              display: none;
            }
          `}
        ></div>
        <Container
          css={css`
            z-index: 1;
          `}
        >
          <div
            css={css`
              padding-top: 220px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: column;
              margin-left: 30px;
              color: white;
              ${Tablet} {
                padding-top: 80px;
              }
              ${Desktop} {
                padding-top: 160px;
              }
            `}
          >
            <BannerQuote
              css={css`
                width: 270px;
                font-size: 25px;
                line-height: 30px;
                ${Tablet} {
                  width: 320px;
                  font-size: 30px;
                  line-height: 38px;
                }
                ${Desktop} {
                  width: 530px;
                  font-size: 50px;
                  line-height: 65px;
                }
              `}
            >
              <FormattedHTMLMessage id="who-we-are.banner.quote" />
            </BannerQuote>
            <h5
              css={css`
                margin-bottom: 0px;
              `}
            >
              <b>
                <FormattedHTMLMessage id="who-we-are.banner.name" />
              </b>
            </h5>
            <div>
              <FormattedHTMLMessage id="who-we-are.banner.position" />
            </div>
          </div>
        </Container>
      </div>
      <Container
        className="below-banner-desc"
        css={css`
          margin-top: 60px;
          text-align: left;
          ${Tablet} {
            margin-top: 100px;
            text-align: center;
          }
          ${Desktop} {
            margin-top: 200px;
          }
        `}
      >
        <h1
          css={css`
            width: 100%;
          `}
          className="title"
        >
          <FormattedHTMLMessage id="v5.who_we_are.below_banner_desc_title" />
        </h1>
        <h5
          className="desc"
          css={css`
            width: 100%;
          `}
        >
          <FormattedHTMLMessage id="v5.who_we_are.below_banner_desc_desc" />
        </h5>

        <div
          css={css`
            display: flex;
            justify-content: flex-start;
            ${Tablet} {
              justify-content: center;
            }
          `}
        >
          <Link to={`/about/career`}>
            <Button>
              <FormattedHTMLMessage id="v5.who_we_are.below_banner_desc_btn" />
            </Button>
          </Link>
        </div>
      </Container>
      <Container
        className="us-progress"
        css={css`
          margin-top: 100px;
          justify-content: flex-start;
          display: flex;
          padding: 0px 30px 0px 25px;
          ${Tablet} {
            justify-content: space-between;
            padding: 0;
            width: 678px !important;
          }
          ${Desktop} {
            padding: 0px 20px;
            width: 1200px !important;
            margin-top: 200px;
          }
        `}
      >
        <div className="up-row non-mobile">
          {[2016, 2018, 2020, 2022].map((value) => {
            return (
              <div
                key={`${value}-${isClient}`}
                className={`progress-card card-${value}`}
              >
                <h3 className="year">{value}</h3>
                <p className="desc">
                  {/* 利用hr来作可控制高度的换行符 */}
                  <FormattedHTMLMessage
                    id={`v5.who_we_are.timeline_${value}`}
                  />
                </p>
                {timeLineMap[value].pics && (
                  <div className="pics">
                    {timeLineMap[value].pics.map((item, index) => {
                      return <MyImg key={item.name + index} imgInfo={item} />;
                    })}
                  </div>
                )}
                {timeLineMap[value].seperatePics && (
                  <div className="seperate-pics">
                    <div className="seperate-pic">
                      <p className="desc">
                        <FormattedHTMLMessage
                          id={`v5.who_we_are.timeline_${value}_left_desc`}
                        />
                      </p>
                      <MyImg
                        imgInfo={{ name: "CRBC", width: [103.7, 103.7, 103.7] }}
                      />
                    </div>
                    <div className="seperate-pic">
                      <p className="desc">
                        <FormattedHTMLMessage
                          id={`v5.who_we_are.timeline_${value}_right_desc`}
                        />
                      </p>
                      <MyImg imgInfo={{ name: "BOCI", width: [95, 95, 95] }} />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="time-line">
          <div className="spots">
            {[1, 2, 3, 4, 5, 6, 7].map((value) => {
              return <span key={value} className="spot"></span>;
            })}
          </div>
        </div>
        <div className="down-row non-mobile">
          {[2017, 2019, 2021].map((value) => {
            return (
              <div
                key={`${value}-${isClient}`}
                className={`progress-card card-${value}`}
              >
                <h3 className="year">{value}</h3>
                <p className="desc">
                  <FormattedHTMLMessage
                    id={`v5.who_we_are.timeline_${value}`}
                  />
                </p>
                {timeLineMap[value].pics && (
                  <div className="pics">
                    {timeLineMap[value].pics.map((item, index) => {
                      return <MyImg key={item.name + index} imgInfo={item} />;
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="mobile-column">
          {[2016, 2017, 2018, 2019, 2020, 2021, 2022].map((value) => {
            return (
              <div
                key={`${value}-${isClient}`}
                className={`progress-card card-${value}`}
              >
                <h3 className="year">{value}</h3>
                <p className="desc">
                  <FormattedHTMLMessage
                    id={`v5.who_we_are.timeline_${value}`}
                  />
                </p>
                {timeLineMap[value].pics && (
                  <div className="pics">
                    {timeLineMap[value].pics.map((item, index) => {
                      return <MyImg key={item.name + index} imgInfo={item} />;
                    })}
                  </div>
                )}
                {timeLineMap[value].seperatePics && (
                  <div className="seperate-pics">
                    <div className="seperate-pic">
                      <p className="desc">
                        <FormattedHTMLMessage
                          id={`v5.who_we_are.timeline_${value}_left_desc`}
                        />
                      </p>
                      <MyImg
                        imgInfo={{ name: "CRBC", width: [103.7, 103.7, 103.7] }}
                      />
                    </div>
                    <div className="seperate-pic">
                      <p className="desc">
                        <FormattedHTMLMessage
                          id={`v5.who_we_are.timeline_${value}_right_desc`}
                        />
                      </p>
                      <MyImg imgInfo={{ name: "BOCI", width: [95, 95, 95] }} />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Container>

      <Container
        css={css`
          margin-top: 100px;
          ${Desktop} {
            margin-top: 200px;
          }
        `}
      >
        <h1
          css={css`
            width: 100%;
            ${Tablet} {
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id="who-we-are.leadership.title" />
        </h1>
        <div
          css={css`
            width: 100%;
            display: flex;
            flex-direction: column;
            ${Tablet} {
              justify-content: space-between;
              flex-direction: row;
            }
            ${Desktop} {
              justify-content: center;
            }
          `}
        >
          {["kelvin", "don"].map((name) => {
            return (
              <div
                key={name}
                css={css`
                  margin: 0px;
                  display: flex;
                  ${Tablet} {
                    display: block;
                  }
                  ${Desktop} {
                    margin: 20px;
                  }
                `}
              >
                <div
                  css={css`
                    width: 140px;
                    height: 140px;
                    margin-bottom: 10px;
                    flex: 0 0 140px;
                    ${Tablet} {
                      margin-right: 18px;
                      width: 180px;
                      height: 180px;
                    }
                    ${Desktop} {
                      margin-right: 0;
                      width: 255px;
                      height: 255px;
                    }
                  `}
                >
                  <Img
                    fluid={data[name].childImageSharp.fluid}
                    imgStyle={{ objectFit: "fill" }}
                  />
                </div>
                <h5
                  css={css`
                    padding-left: 10px;
                  `}
                >
                  <b>
                    <FormattedHTMLMessage
                      id={`who-we-are.leadership.${name}.name`}
                    />
                  </b>
                  <br />
                  <FormattedHTMLMessage
                    id={`who-we-are.leadership.${name}.position`}
                  />
                </h5>
              </div>
            );
          })}
        </div>
      </Container>

      <Container
        className="advisors"
        css={css`
          margin-top: 100px;
          display: flex;
          flex-direction: column;
          ${Tablet} {
            align-items: center;
            padding: 0 83px 0 104px;
          }
          ${Desktop} {
            margin-top: 200px;
            padding: 0;
          }
        `}
      >
        <h1>
          <FormattedHTMLMessage id="who-we-are.advisors.title" />
        </h1>
        <div
          className="advisors-line"
          css={css`
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            ${Tablet} {
              flex-direction: row;
              flex-wrap: wrap;
            }
            ${Desktop} {
            }
          `}
        >
          {[6, 3, 0, 1, 8, 9].map((i) => {
            if (i === 0) {
              return <hr key="0" className="flex-hr" />;
            } else
              return (
                <div
                  className={`advisors-card ${
                    i === 9 ? "placeholder-card" : ""
                  }`}
                  key={i}
                  css={css`
                    display: flex;
                    flex-direction: column;
                    ${Tablet} {
                    }
                    ${Desktop} {
                    }
                  `}
                >
                  {i !== 9 && (
                    <img
                      className="advisors-avatar"
                      src={`/who-we-are/advisors-${i}.png`}
                    />
                  )}
                  <h5 className="advisors-name">
                    <b>
                      {/* 一共8位投资顾问，编号9就是用来占位的 */}
                      {i !== 9 && (
                        <FormattedHTMLMessage
                          id={`who-we-are.advisors.${i}.name`}
                        />
                      )}
                    </b>
                  </h5>
                  <h5 className="advisors-title">
                    {i !== 9 && (
                      <FormattedHTMLMessage
                        id={`who-we-are.advisors.${i}.title`}
                      />
                    )}
                  </h5>
                </div>
              );
          })}
        </div>
      </Container>

      <Container
        css={css`
          margin-top: 100px;
          width: 100% !important;
          padding: 0px;
          ${Desktop} {
            margin-top: 200px;
            width: 1200px !important;
            padding: 0px 20px;
          }
        `}
      >
        <h1
          css={css`
            width: 100%;
            text-align: left;
            padding-left: 20px;
            ${Tablet} {
              padding: 0px;
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id={`who-we-are.awards.title`} />
        </h1>

        <ScrollContainer>
          <div
            css={css`
              width: auto;
              display: flex;
              flex-wrap: nowrap;
              ${Tablet} {
                width: 100%;
                flex-wrap: wrap;
                justify-content: center;
                padding: 0px;
              }
              ${Desktop} {
                padding: 0px 50px;
              }
            `}
          >
            {[
              { name: "edigest", width: 160 },
              { name: "hkict", width: 141 },
              { name: "blue", width: 141 },
              { name: "etnet", width: 109 },
              { name: "deloitte", width: 189 },
              { name: "synced", width: 181 },
              { name: "kpmg", width: 160 },
              { name: "szfcia", width: 167 },
              { name: "iegc", width: 91 },
              { name: "ftsu", width: 91 },
            ].map(({ name, width }) => {
              return (
                <div
                  key={name}
                  css={css`
                    margin: 20px 0px;
                    margin-left: 20px;
                    ${Tablet} {
                      margin: 20px;
                    }
                    ${Desktop} {
                      margin: 30px;
                    }
                  `}
                >
                  <div
                    css={css`
                      width: 140px;
                      height: 140px;
                      background: #f2f2f2;
                      border-radius: 10px;
                      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
                      display: flex;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: center;
                      ${Tablet} {
                        padding: 10px;
                        width: 200px;
                        height: 200px;
                      }
                      ${Desktop} {
                        width: 240px;
                        height: 240px;
                      }
                    `}
                  >
                    <div
                      css={css`
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 80px;
                        ${Tablet} {
                          height: 117px;
                        }
                        ${Desktop} {
                          height: 140px;
                        }
                      `}
                    >
                      <div
                        css={css`
                          width: ${Math.round((width * 140) / 240)}px;
                          ${Tablet} {
                            width: ${Math.round((width * 200) / 240)}px;
                          }
                          ${Desktop} {
                            width: ${width}px;
                          }
                        `}
                      >
                        <Img
                          fluid={data[name].childImageSharp.fluid}
                          imgStyle={{ objectFit: "fill" }}
                        />
                      </div>
                    </div>
                    <h5
                      css={css`
                        margin-bottom: 0px;
                        text-align: center;
                        font-size: 12px;
                        ${Tablet} {
                          font-size: 16px;
                        }
                        ${Desktop} {
                          font-size: 20px;
                        }
                      `}
                    >
                      <b>
                        {!["kpmg"].includes(name) && (
                          <FormattedHTMLMessage
                            id={`who-we-are.awards.${name}.name`}
                          />
                        )}
                      </b>
                    </h5>
                    <h5
                      css={css`
                        margin-bottom: 0px;
                        text-align: center;
                        font-size: 12px;
                        line-height: 1.25;
                        ${Tablet} {
                          font-size: 16px;
                        }
                        ${Desktop} {
                          font-size: 20px;
                        }
                      `}
                    >
                      <FormattedHTMLMessage
                        id={`who-we-are.awards.${name}.title`}
                      />
                    </h5>
                  </div>
                </div>
              );
            })}
            <StartEndPadding mobileOnly />
          </div>
        </ScrollContainer>
      </Container>

      <Container
        css={css`
          margin-top: 100px;
          width: 100% !important;
          padding: 0px;
          ${Tablet} {
            width: 768px !important;
            padding: 0px 20px;
          }
          ${Desktop} {
            margin-top: 200px;
            width: 1200px !important;
          }
        `}
      >
        <h1
          css={css`
            width: 100%;
            text-align: left;
            padding-left: 20px;
            ${Tablet} {
              padding: 0px;
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id={`who-we-are.shareholders.title`} />
        </h1>
        <h4
          css={css`
            width: 100%;
            text-align: left;
            padding-left: 20px;
            ${Tablet} {
              padding: 0px;
              text-align: center;
            }
          `}
        >
          <FormattedHTMLMessage id={`who-we-are.shareholders.subtitle`} />
        </h4>
        <ScrollContainer>
          <div
            css={css`
              width: auto;
              display: flex;
              flex-wrap: nowrap;
              ${Tablet} {
                width: 100%;
                flex-wrap: wrap;
                justify-content: center;
                padding: 0px;
              }
              ${Desktop} {
                padding: 0px 50px;
              }
            `}
          >
            {[
              { name: "hkust", width: 200 },
              { name: "alibaba", width: 200 },
              { name: "bohai", width: 213 },
              { name: "lenovo", width: 92 },
              { name: "cyberport", width: 200 },
              { name: "zhengHe", width: 92 },
              { name: "twosigma", width: 150 },
            ].map(({ name, width }) => {
              return (
                <div
                  key={name}
                  css={css`
                    margin: 20px 0px;
                    margin-left: 20px;
                    ${Tablet} {
                      margin: 20px;
                    }
                    ${Desktop} {
                      margin: 30px;
                    }
                  `}
                >
                  <div
                    css={css`
                      width: 140px;
                      height: 140px;
                      background: #f2f2f2;
                      border-radius: 10px;
                      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      ${Tablet} {
                        width: 200px;
                        height: 200px;
                      }
                      ${Desktop} {
                        width: 240px;
                        height: 240px;
                      }
                    `}
                  >
                    <div
                      css={css`
                        width: ${Math.round((width * 140) / 240)}px;
                        ${Tablet} {
                          width: ${Math.round((width * 200) / 240)}px;
                        }
                        ${Desktop} {
                          width: ${width}px;
                        }
                      `}
                    >
                      <Img
                        fluid={data[name].childImageSharp.fluid}
                        imgStyle={{ objectFit: "fill" }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            <StartEndPadding mobileOnly />
          </div>
        </ScrollContainer>
      </Container>
    </Layout>
  );
};

export default WhoWeArePage;
